import StepId from "@/model/progress/StepId"

const StartView = () => import("@/views/StartView")

export default [
    {
        name: "startWithDefaultEntityKey",
        path: "/start",
        component: StartView,
        meta: {
            public: true,
            step: StepId.APPLICANT_INFO
        },
    },
    {
        name: "startWithEntityKey",
        path: "/start/entity-keys/:entityKey",
        component: StartView,
        meta: {
            public: true,
            step: StepId.APPLICANT_INFO
        },
    },
    {
        name: "startWithToken",
        path: "/start/tokens/:token",
        component: StartView,
        meta: {
            public: true,
            step: StepId.APPLICANT_INFO
        },
    },
]
